export function sendOnChange() {
  const selects = document.querySelectorAll("select.send-on-change");

  selects.forEach((select) => {
    // Dodaj nasłuchiwanie na zdarzenie zmiany
    select.addEventListener("change", function () {
      // Znajdź formularz, w którym znajduje się element select
      const form = select.closest("form");
      if (form) {
        // Wyślij formularz
        form.submit();
      }
    });
  });
}
